import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { FullExperienceFieldsFragment } from '@/generated/graphql';
import LocationMap from './location-map';

const Container = styled(Grid)`
  height: auto;
  width: 100%;
  margin-bottom: 100px;
  @media (max-width: 768px) {
    padding-top: unset;
    margin-bottom: 60px;
    padding: 0 20px;
  }
`;
const Title = styled(Typography)`
  color: #251628;
  text-align: center;
  font-family: var(--font-work-sans);
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 159.3%;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
  }
`;
const Content = styled(Grid)`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
`;
const Subtitle = styled(Typography)`
  color: #251628;
  font-family: var(--font-work-sans);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 159.3%;
  align-items: center;
  text-align: justify;
  margin-bottom: 30px;
  @media (max-width: 768px) {
  }
`;
interface InPersonProps {
  experience: FullExperienceFieldsFragment;
}
const InPerson = ({ experience }: InPersonProps) => {
  const [longLat, setLongLat] = useState({ lng: -79.4163, lat: 43.7001 });
  useEffect(() => {
    setLongLat({
      lng: experience.approximateLocation
        ? experience.approximateLocation.coordinates[0]
        : longLat.lng,
      lat: experience.approximateLocation
        ? experience.approximateLocation.coordinates[1]
        : longLat.lat,
    });
  }, [experience, longLat.lat, longLat.lng, setLongLat]);
  return (
    <Container container>
      <Content item>
        <Title id="in-person">This experience is in-person!</Title>
        <Subtitle>{`You'll meet your host in ${experience.locality}, ${experience.administrativeAreaLevel1}, near the area below! The exact address will be sent to you when the host confirms the experience!`}</Subtitle>
        <LocationMap lat={longLat.lat} lng={longLat.lng} />
      </Content>
    </Container>
  );
};

export default InPerson;
